import { render, staticRenderFns } from "./AllProjectsView.vue?vue&type=template&id=0b69db28&scoped=true&"
import script from "./AllProjectsView.vue?vue&type=script&lang=js&"
export * from "./AllProjectsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b69db28",
  null
  
)

export default component.exports